import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import Slide from "../slide.js";
import People_item_0 from './People_item_0.js';
import People_item_1 from './People_item_1.js';
import People_item_2 from './People_item_2.js';
import People_item_4 from './People_item_4.js';
import People_img from "../img/People.png";
import Crow_img_1 from "../img/Crow/1.png";
import Crow_img_2 from "../img/Crow/2.png";
import Crow_img_3 from "../img/Crow/5.png";

function People(){
    return (
        <Wrapper>
            <Slide imgURL={People_img} inputText="People"/>
            <People_item_0/>
            <People_item_1/>
            <People_item_2/>
            <People_item_4/>
            <Crow_img1 src={Crow_img_1}/>
            <Crow_img2 src={Crow_img_2}/>
            <Crow_img3 src={Crow_img_3}/>
        </Wrapper>
    )
}  

const Wrapper = styled.div`
position : relative; 
top : 90px;
width : 1200px;
margin : 0 auto;
`
const Crow_img1 = styled.img`
width : 150px; 
height : 149px;
position : absolute;
top:4410px;
left: 200px;
`
const Crow_img2 = styled.img`
width : 150px; 
height : 86.828px;
position : absolute;
top:2950px;
right :130px;
`
const Crow_img3 = styled.img`
width : 300px; 
height : 177.867px;
position : absolute;
top:180px;
right : 0px;
transform: rotate3d(0.2, 1, 0, 180deg);



`
export default People;